import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AnyObject } from '@mri/types';

@Injectable()
export class ManifestInterceptorService implements HttpInterceptor {

  intercept(req: HttpRequest<AnyObject>, next: HttpHandler): Observable<HttpEvent<AnyObject>> {
    if (req.url.endsWith('/manifest.webmanifest')) {
      const dynamicManifest = {
        name: "Dynamic PWA App",
        short_name: "PWA App",
        start_url: "/",
        display: "standalone",
        background_color: "#ffffff",
        theme_color: "#000000",
        icons: [
          {
            src: "assets/images/logo-dark.png",
            sizes: "72x72",
            type: "image/png"
          },
          // Añade más iconos aquí...
        ]
      };
      const response = new HttpResponse({ status: 200, body: dynamicManifest });
      return of(response);
    } else {
      return next.handle(req);
    }
  }
}
